module.exports = __webpack_public_path__ + "static/media/app-bar-login.45921610.svg";